export default "__VITE_ASSET__CLBjFXOg__"